import React, { Component } from 'react';
import TableModal from '../../../../UI/TableModal';
// import { getSelectedValueBasedOnField } from '../../../../../../Utils/CommonFunctions';
import {callGET} from '../../../../../Utils/ApiUtil';
// import convertToHtml from '../convertDraftjsToHtml';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as actions from '../../../../../store/actions';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import QuickCreateForms from '../../../../../Containers/LayoutContainer/QuickCreateForms';

class SingleUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isModalOpen:this.props.isModalOpen,
        status:null,
        lookup_layout:this.props.lookup_layout,
        page:this.props.page,
        isConfirmPage:false,
        tableRecords:{
          tableHead:[],
          tableData:[], 
          pagination:{
            page:0,
            orderBy:'',
            perPage:10,
            direction:'ASC',
            totalRecords:0,
            search:''
          }
        },
        selectedValueCustom: this.props.selectedValue
    }
  }
    componentDidUpdate = (prevProps) => {
      if(prevProps.isModalOpen !== this.props.isModalOpen) {
        this.setState({isModalOpen: this.props.isModalOpen});
        if(this.props.isModalOpen===true){
          // alert('ss');
          this.LayoutsFormsList(this.state.tableRecords.pagination,true);
        }
      }
    }
    
    onChangeSelectLookup = (rowId,wthis)=>{
      console.log(rowId);
      const tableDataSel = this.state.tableRecords;
      tableDataSel.tableData.data.map((item,index)=>{
        if(item.rowId===rowId){
          tableDataSel.tableData.data[index].className='selected';
          tableDataSel.tableData.data[index].data.RadioButton.checked=true;
          const tableDataCol = tableDataSel.tableData.data[index].data;
          let displayName = [];
          displayName.push(tableDataCol.firstName.value+' '+tableDataCol.lastName.value);
          // this.props.setLookupValuesFromList({
          //   label:displayName.join(' '),
          //   value:rowId
          // });
        }else{
          tableDataSel.tableData.data[index].className='';
          tableDataSel.tableData.data[index].data.RadioButton.checked=false;
        }
      })
      this.setState({tableRecords:{
        ...tableDataSel
      }, selectedValueCustom: rowId })
    }


  //MODAL CONFIRM
  confirmLoopupModalHandler = () => {
    let rowId = this.state.selectedValueCustom;
    const tableDataSel = this.state.tableRecords;
      tableDataSel.tableData.data.map((item,index)=>{
        if(item.rowId===rowId){
          tableDataSel.tableData.data[index].className='selected';
          tableDataSel.tableData.data[index].data.RadioButton.checked=true;
          const tableDataCol = tableDataSel.tableData.data[index].data;
          let displayName = [];
          displayName.push(tableDataCol.firstName.value+' '+tableDataCol.lastName.value);
          this.props.setLookupValuesFromList({
            label:displayName.join(' '),
            value:rowId
          });
        }else{
          tableDataSel.tableData.data[index].className='';
          tableDataSel.tableData.data[index].data.RadioButton.checked=false;
        }
      })
      this.setState({tableRecords:{
        ...tableDataSel
      }, selectedValueCustom: rowId })
      this.props.cancelLoopupModalHandler()
  }

 //MODAL POPUP 
  openQuickCreatePopup = () =>{
    this.setState({isQuickAddModalOpen:true});
  }
  //MODAL POPUP - CANCEL
  closeQuickCreatePopup = () =>{
    this.setState({isQuickAddModalOpen: false});
  }    
 recordsChangeHandler = (pagination)=>{
    this.LayoutsFormsList(pagination)
 }  
 goBackLookupList =()=>{
   this.LayoutsFormsList(this.state.tableRecords.pagination,true);
 }
  LayoutsFormsList =(pagination,loader=false) =>{
    const windowName = this.props.windowName;
    const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;
    this.setState({
      tableRecords:{
        ...this.state.tableRecords,
        pagination:pagination
      }
    })
    if(loader===true){ this.props.Loader(); }
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    callGET('users/fetch-users/active'+queryString)
    .then(res => {
      if(loader===true){ this.props.Loader(); }
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
          const resData = response.data;
          this.setState({lookup_layout:{
            // lookupLayoutId:resData.lookup_layout_id,
            moduleId:resData.module_id,
            windowId:resData.window_id,
            windowName:windowName
          }});
          let updateTableData = [];
          let fieldsRow;
          let tablehead = [
            {
              name:'',
              type:"RadioButton",
              columnId:"",
              isShow:true
            },
            {
              name:'First Name',
              type:"HyperLink",
              columnId:"",
              isShow:true
            },
            {
              name:'Last Name',
              type:"HyperLink",
              columnId:"",
              isShow:true
            },
            {
              name:'E-mail',
              type:"HyperLink",
              columnId:"",
              isShow:true
            },
            {
              name:'Contact number',
              type:"HyperLink",
              columnId:"",
              isShow:true
            },
            {
              name:'Profile',
              type:"HyperLink",
              columnId:"",
              isShow:true
            },
            {
              name:'Role',
              type:"HyperLink",
              columnId:"",
              isShow:true
            }
          ]
          // response.data.grid_list.map((header)=>{
          //   tablehead.push({
          //     name:header.display_name,
          //     type:"HyperLink",
          //     columnId:header.table_descriptor_id,
          //     isShow:header.is_show,
          //   });
          // }) 
          console.log(this.props);
          response.data.content.map((item,itemIndex)=>{
            fieldsRow = {}
            fieldsRow = {
                ...fieldsRow,
                RadioButton:{
                  checked:(this.props.selectedValue && this.props.selectedValue!=null && this.props.selectedValue===item.id)? true:false,
                  name:'windowCheckbox'
                },
                firstName:{
                  value:item.first_name,
                  className:'primary_color cursor-pointer'
                },
                lastName:{
                  value:item.last_name,
                  className:'primary_color cursor-pointer'
                },
                email:{
                  value:item.email
                },
                mobile_number:{
                  value:item.mobile_number
                },
                profile_name:{
                  value:item.profile_name
                },
                role_name:{
                  value:item.role_name,
                  className:'primary_color cursor-pointer'
                }     
            }
            
              // fieldsRow = {
              //       ...fieldsRow,
              //       [item.id]:{
              //             className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
              //             value:(item.first_name)
              //       }
              //     }
          updateTableData.push({
            clickHandler:this.onChangeSelectLookup.bind(this,item.id),
            className:(this.props.selectedValue && this.props.selectedValue!=null && item.id===this.props.selectedValue)? 'selected':'',
            rowId:item.id,
            data:fieldsRow
          })
        })  
          // console.log(updateTableData);
          
          const totalRecords = response.data.total_elements;
          this.setState({status:200, tableRecords:{
            tableData:{data:updateTableData,status:200},
            tableHead:tablehead,
            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
        }else{
          const totalRecords = 0;//response.data.totalElements;
          this.setState({status:200, tableRecords:{
            tableData:{data:[],status:400},
            tableHead:this.state.tableRecords.tableHead ,
            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
        }
      }
    })
  }




    
    render () {
        const ModalTitle ="User List";
        const modalType = 'tableList';
        const modalButtonList = [
            {
              attributes:{
                className:"btn btn btn-cancel mr-2",
                "data-dismiss":"modal",
                "id":"closeAddNewRoleModal",
              },
              clickHandler:this.props.cancelLoopupModalHandler,
              name:"Cancel"
            }
          ];
          const FooterButtonList = [
            {
              attributes:{
                className:"btn primary_bg cursor-pointer",
                "data-dismiss":"modal",
              },
              disabled:(this.state.selectedValueCustom && this.state.selectedValueCustom!==null)? false:true,
              //clickHandler:this.props.cancelLoopupModalHandler,
              clickHandler:this.confirmLoopupModalHandler,
              name:"Confirm"
            }
          ];
        try{
          return (
            <Wrp>
            <TableModal 
              isModalOpen={this.state.isModalOpen}
              title={ModalTitle}
              modalType={modalType}
              buttonList={modalButtonList}
              tableRecords={this.state.tableRecords}
              FooterButtonList={FooterButtonList}
              recordsChangeHandler={this.LayoutsFormsList}
              // selectedLookupCount = {this.props.selectedLookupCount.length}
              isConfirmPage={this.state.isConfirmPage}
               />
               {(this.state.isQuickAddModalOpen===true)?
                <QuickCreateForms 
                  succMessage={this.props.succMessage}
                  failMessage={this.props.failMessage}  
                  Loader={this.props.Loader}
                  closeQuickCreatePopup={this.closeQuickCreatePopup}
                  isQuickAddModalOpen={this.state.isQuickAddModalOpen}
                  lookup_layout={this.state.lookup_layout}
                  goBackLookupList={this.goBackLookupList}
                />  
             :''} 
            </Wrp>
          )
        }catch(e){
          this.props.failMessage("Something went wrong...");
        }
        
    }
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (bool) => dispatch(actions.loader(bool)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))    
  };
}
export default
  connect(
    null, 
    mapDispatchToProps
  )(withRouter(SingleUserModal));
// export default SingleUserModal;